export enum CheckerContactTypeEnum {
  VALIDATED = 'VALIDATED',
  NOT_VALIDATED = 'NOT_VALIDATED',
  INVALID = 'INVALID',
}